import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
export function WhatChanges() {
  const changes = ['Empiezas a ver qué formatos generan intención', 'Qué hooks atraen a la persona correcta', 'Qué CTA dispara DMs/clicks', 'Qué oferta tiene demanda real'];
  return <Section className="bg-[#0a0a0a]" data-id="element-356">
      <div className="glow-line w-full max-w-xs mx-auto mb-16" data-id="element-357" />
      <div className="max-w-3xl mx-auto text-center" data-id="element-358">
        <h2 className="text-3xl font-bold text-white mb-4" data-id="element-359">
          Lo que cambia cuando lo aplicas
        </h2>
        <p className="text-xl text-gray-400 mb-12" data-id="element-360">No es magia. Es claridad.</p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-left" data-id="element-361">
          {changes.map((change, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1,
          duration: 0.4
        }} className="glass-card p-5 border-l-2 border-[#14b8a6]/40" data-id="element-362">
              <p className="text-white font-medium" data-id="element-363">{change}</p>
            </motion.div>)}
        </div>

        <div className="mt-12 luxury-border p-8 md:p-10" data-id="element-364">
          <p className="text-lg text-gray-300" data-id="element-365">
            Y sobre todo: <br data-id="element-366" />
            <span className="text-white font-bold text-xl block mt-3" data-id="element-367">
              Dejas de sentir que estás "jugando a redes" y empiezas a operar
              como emprendedor digital.
            </span>
          </p>
        </div>
      </div>
    </Section>;
}